import { useEffect } from 'react';
import throttle from 'lodash/throttle';
var THROTTLE_TIMEOUT = 200;
export function useOnScroll(contentRef, onScrolled, throttleTimeout, preventLeakyScroll) {
    if (throttleTimeout === void 0) { throttleTimeout = THROTTLE_TIMEOUT; }
    if (preventLeakyScroll === void 0) { preventLeakyScroll = true; }
    useEffect(function () {
        var contentNode = contentRef.current;
        if (!onScrolled || !contentNode) {
            return;
        }
        var handleScroll = throttle(function () {
            var scrollTop = contentNode.scrollTop, scrollHeight = contentNode.scrollHeight, clientHeight = contentNode.clientHeight;
            var distanceToBottom = scrollHeight - scrollTop - clientHeight;
            onScrolled(scrollTop, distanceToBottom);
        }, throttleTimeout, { leading: true, trailing: true });
        // can't use NoLeakyScroll because also need to deal with scroll events
        var handleWheel = function (e) {
            if (!contentNode ||
                contentNode.scrollHeight <= contentNode.clientHeight) {
                return;
            }
            if (e.deltaY < 0 && contentNode.scrollTop === 0) {
                e.preventDefault();
            }
            if (e.deltaY > 0 &&
                contentNode.scrollTop ===
                    contentNode.scrollHeight - contentNode.clientHeight) {
                e.preventDefault();
            }
        };
        handleScroll();
        contentNode.addEventListener('scroll', handleScroll);
        if (preventLeakyScroll) {
            contentNode.addEventListener('wheel', handleWheel);
        }
        return function () {
            contentNode.removeEventListener('scroll', handleScroll);
            contentNode.removeEventListener('wheel', handleWheel);
        };
    }, [contentRef, onScrolled, preventLeakyScroll, throttleTimeout]);
}
//# sourceMappingURL=useOnScroll.js.map